export const UnauthorizedProcess = 'Unauthorized process!';


// WEBPACK FOOTER //
// ./src/messages/systemMessages.js